import React, { useState, useEffect, useCallback } from "react";
import UserSidbar from "../Layout/UserSidbar";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getcounsellorWallet } from "../../redux/action/CounsellorApi";
import Loader from "../Pages/Loader";

const Wallet = ({ isAuthenticated = false, user }) => {
  const [page, setPage] = useState(1);

  const { toBePaid, totalEarn, totalPages, counsellorPaymentHistory, message, error, loading } = useSelector(
    state => state.Counsellor
  );


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const chatDetails = useCallback(() => {
    const postdata = {
      userId: localStorage.getItem("userId"),
      hash_token: localStorage.getItem("hashToken"),
      page: page,
      limit: 10,
    };

    dispatch(getcounsellorWallet(postdata));
  }, [dispatch, page]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    } else {
      chatDetails();
    }

    if (error) {
      toast.error(error);
      dispatch({ type: "clearError" });
    }

    if (message) {
      toast.success(message);
      dispatch({ type: "clearMessage" });
    }
  }, [navigate, dispatch, chatDetails, isAuthenticated, error, message]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  return (
    <>
     

      <section className="wallet_page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <UserSidbar user={user} />
            </div>
            <div className="col-lg-9 col-md-9 col-sm-6 col-xs-12">
              <div className="wallet_right">
                <div className="row charts_sec">
                  {/* <div className="col-md-12 recharge_his">
                    <h5 className="">
                      Payment History <img src="./assets/images/recharge.svg" alt="" />
                    </h5>
                  </div> */}

                      <div class="col-md-12 recharge_his">
                      <h5 class=""> Payment History <img src="./assets/images/recharge.svg" alt="" /></h5>
                      <h5>  To Be Paid : ₹{toBePaid} </h5>
                      <h5>  Total Earn : ₹{totalEarn} </h5>
                      </div>


                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    {loading ? <Loader /> :
                    <>
                    <div className="recharge_history">
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover align-middle text-center">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              <th>Total Minute</th>
                              <th>Amount</th>
                              <th>Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {counsellorPaymentHistory && counsellorPaymentHistory.length > 0 ? (
                              counsellorPaymentHistory.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.name || "N/A"}</td>
                                  <td>{item.call_time || "N/A"}</td>
                                  <td>₹{item.credit || "0.00"}</td>
                                  <td>{item.date}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" className="text-center">No Records Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                      </div>

                      <div className="recharge_all">
                        {totalPages > 1 && (
                          <div className="pagination-wrapper text-center mt-4">
                            <button
                              className={`pagination-btn ${page === 1 ? "disabled" : ""}`}
                              onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                              disabled={page === 1}
                            >
                              &laquo; Prev
                            </button>

                            <span className="pagination-page">Page {page} of {totalPages}</span>

                            <button
                              className={`pagination-btn ${page === totalPages ? "disabled" : ""}`}
                              onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                              disabled={page === totalPages}
                            >
                              Next &raquo;
                            </button>
                          </div>
                        )}
                      </div>


                    </div>
                    </>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Wallet;
